import { Observable } from '@code-expert/fp-ts-rxjs';
import { option } from '@code-expert/prelude';
import { eqEntityById } from './Entity.js';
import { publicationEventAdt } from './PublicationEvent.js';
export const optionalSingletonReducer = (event) => (prevState) => {
    const panic = (message) => {
        const cause = { prevState, event };
        throw new Error(message, { cause });
    };
    const isSameEntity = option.elem(eqEntityById);
    return publicationEventAdt().fold(event, {
        initial: (es) => {
            if (es.length > 1)
                panic('Singleton publication did not receive a singular entity');
            else
                return option.fromNullable(es[0]);
        },
        insert: (e) => {
            if (option.isSome(prevState) && !isSameEntity(e)(prevState))
                panic('Singleton publication received extraneous entity');
            else
                return option.some(e);
        },
        update: (e) => {
            if (!option.isSome(prevState))
                panic('Singleton publication received update before insert');
            else if (!isSameEntity(e)(prevState))
                panic('Singleton publication received update to wrong entity');
            else
                return option.some(e);
        },
        delete: (id) => {
            // We must be idempotent here, so delete before insert is acceptable
            if (option.isSome(prevState) && !isSameEntity({ _id: id })(prevState))
                panic('Singleton publication received delete to wrong entity');
            else
                return option.none;
        },
    });
};
export const aggregateOptionalSingleton = () => (source) => new Observable((subscriber) => {
    let state;
    return source.subscribe({
        complete: () => {
            subscriber.complete();
        },
        error: (e) => {
            subscriber.error(e);
        },
        next: (event) => {
            if (state == null) {
                if (event._tag !== 'initial') {
                    subscriber.error(new Error('Publication received update before initialisation', {
                        cause: { event },
                    }));
                    return;
                }
                state = option.none;
            }
            try {
                subscriber.next((state = optionalSingletonReducer(event)(state)));
            }
            catch (e) {
                subscriber.error(e);
            }
        },
    });
});
//# sourceMappingURL=OptionalSingleton.js.map